import React from "react";
import { Box, Button, Card, Divider, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { AppColors } from "../resources/AppColors";
import TextMonitoring from "./TextMonitoring";
import { textType } from "resources/AppTexts";
import { CommonTexts } from "locale/es";

const FormMonitoring = ({
  children,
  title,
  submitForm,
  resetFormInputs,
  isEdit = false,
  isExport = false,
  ...other
}) => {
  return (
    <Card
      className='mb-1'
      sx={{
        backgroundColor: AppColors.WHITE,
        color: AppColors.PRIMARY,
        paddingBottom: 3,
      }}
    >
      <Box
        component='form'
        autoComplete='off'
        onSubmit={submitForm}
        {...other}
        sx={{
          display: "flex",
          flexDirection: "column",
          margin: "auto",
          maxWidth: "95%",
        }}
      >
        <TextMonitoring type={textType.TITLE_MEDIUM} text={title} />
        {children}
        <Divider />
        <Box mt={2} sx={{ display: "flex", justifyContent: "flex-end" }}>
          {!isExport && (
            <Button
              onClick={resetFormInputs}
              variant='contained'
              sx={{ width: { xs: 100, sm: 125 }, bgcolor: "red" }}
            >
              <Typography variant='button_text'>{CommonTexts.RESET}</Typography>
            </Button>
          )}
          <Button
            variant='contained'
            type='submit'
            sx={{
              width: { xs: 100, sm: 125 },
              marginLeft: 2,
              bgcolor: AppColors.PRIMARY,
            }}
            data-cy='button-submit-form'
          >
            <Typography variant='button_text'>
              {isEdit ? CommonTexts.SAVE : isExport ? CommonTexts.EXPORT : CommonTexts.CREATE}
            </Typography>
          </Button>
        </Box>
      </Box>
    </Card>
  );
};

FormMonitoring.propTypes = {
  children: PropTypes.node.isRequired,
  // title: PropTypes.string.isRequired,
  // submitForm: PropTypes.func.isRequired
};

export default FormMonitoring;
